(function() {
  var currentSearchTerm = '';
  var currentAjaxRequest = null;
  var currentHoverTerm = null;

  function fetchSuggestions(term, signal) {
    if (!term || term.length < 1) {
      return Promise.resolve([]);
    }

    var predictiveSearchUrl = (window.routes && window.routes.predictive_search_url)
      ? window.routes.predictive_search_url
      : '/search/suggest';

    var url = predictiveSearchUrl + '?q=' + encodeURIComponent(term) + '&resources[type]=query&resources[limit]=8&section_id=api-predictive-search';

    return fetch(url, { signal: signal })
      .then(function(response) {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then(function(text) {
        var suggestions = [];

        suggestions.push({
          text: term,
          styled_text: term,
          url: '/search?q=' + encodeURIComponent(term)
        });

        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');
        var section = doc.querySelector('[data-section-id="api-predictive-search"]') || doc.body;
        var queryItems = section.querySelectorAll('.predictive-search__item');
        queryItems.forEach(function(item) {
          var link = item.querySelector('.predictive-search__link');
          if (link) {
            var span = link.querySelector('span');
            var queryText = span ? span.getAttribute('aria-label') : '';
            var styledText = span ? span.textContent.trim() : '';
            var queryUrl = link.getAttribute('href') || '/search?q=' + encodeURIComponent(queryText);

            if (queryText && queryText !== term) {
              suggestions.push({
                text: queryText,
                styled_text: styledText || queryText,
                url: queryUrl
              });
            }
          }
        });

        var seen = {};
        suggestions = suggestions.filter(function(item) {
          var key = item.text || item.styled_text;
          if (seen[key]) {
            return false;
          }
          seen[key] = true;
          return true;
        }).slice(0, 8);

        return suggestions;
      })
      .catch(function(error) {
        if (error.name === 'AbortError' || error.code === 20) {
          return [];
        }
        return [{
          text: term,
          styled_text: term,
          url: '/search?q=' + encodeURIComponent(term)
        }];
      });
  }

  function renderSuggestions(suggestions, activeTerm, modal) {
    if (!modal) return;
    var list = modal.querySelector('#suggestions-list');
    if (!list) return;

    list.innerHTML = '';

    suggestions.forEach(function(query, index) {
      var itemDiv = document.createElement('div');
      itemDiv.className = 'predictive-search__item';
      itemDiv.id = 'predictiveSearchOptionQuery-' + (index + 1);
      itemDiv.setAttribute('role', 'option');
      itemDiv.setAttribute('aria-selected', 'false');

      var link = document.createElement('a');
      link.className = 'predictive-search__link';
      link.href = Shopify.routes.root +'search?q=' + encodeURIComponent(query.text || query.styled_text);
      link.setAttribute('tabindex', '-1');
      link.setAttribute('data-term', query.text || query.styled_text);
      link.classList.add('suggestion-item-link');

      var span = document.createElement('span');
      span.setAttribute('aria-label', query.text || query.styled_text);
      span.textContent = query.styled_text || query.text;

      link.appendChild(span);
      itemDiv.appendChild(link);

      var suggestionText = query.text || query.styled_text;
      if (suggestionText === activeTerm) {
        link.classList.add('active');
        itemDiv.setAttribute('aria-selected', 'true');
      }

      var li = document.createElement('li');
      li.appendChild(itemDiv);
      list.appendChild(li);
    });
  }

  function renderProductItem(product) {
    if (!product || !product.handle) return '';

    var imageSrc = '';
    var imageAlt = product.title || '';

    if (product.featured_image) {
      imageSrc = product.featured_image;
    } else if (product.images && product.images.length > 0) {
      imageSrc = product.images[0];
    } else if (product.variants && product.variants.length > 0 && product.variants[0].featured_image) {
      imageSrc = product.variants[0].featured_image;
    }

    if (imageSrc) {
      imageSrc = imageSrc.replace(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i, '_600x.$1');
    }

    var productUrl = Shopify.routes.root + 'products/' + product.handle;
    var title = product.title || '';
    var escapedTitle = title.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var escapedAlt = imageAlt.replace(/"/g, '&quot;');

    return '<div class="product-item product-item-' + product.id + ' result-item">' +
      '<a href="' + productUrl + '">' +
        '<div class="image-wrapper">' +
          '<div class="image">' +
            '<div class="img media">' +
              (imageSrc ? '<img src="' + imageSrc + '" alt="' + escapedAlt + '" loading="lazy" />' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="info">' +
          '<div class="title heading_font">' + escapedTitle + '</div>' +
        '</div>' +
      '</a>' +
    '</div>';
  }

  function renderArticleItem(article) {
    if (!article || !article.url) return '';

    var imageSrc = '';
    var imageAlt = article.title || '';

    if (article.image) {
      imageSrc = article.image;
    } else if (article.featured_image) {
      imageSrc = article.featured_image;
    }

    if (imageSrc) {
      imageSrc = imageSrc.replace(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?/i, '_600x.$1');
    }

    var articleUrl = article.url || '';
    var title = article.title || '';
    var escapedTitle = title.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var escapedAlt = imageAlt.replace(/"/g, '&quot;');

    return '<div class="article-item article-item-' + (article.id || '') + ' result-item">' +
      '<a href="' + articleUrl + '">' +
        '<div class="image-wrapper">' +
          '<div class="image">' +
            '<div class="img media">' +
              (imageSrc ? '<img src="' + imageSrc + '" alt="' + escapedAlt + '" loading="lazy" />' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="info">' +
          '<div class="title heading_font">' + escapedTitle + '</div>' +
        '</div>' +
      '</a>' +
    '</div>';
  }

  function createAbortController() {
    if (currentAjaxRequest) {
      currentAjaxRequest.abort();
    }
    return new AbortController();
  }

  function fetchJSON(url, signal) {
    return fetch(url, { signal: signal })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      });
  }

  function fadeIn(element, duration) {
    if (!element) return;
    element.style.display = 'flex';
    element.style.opacity = '0';
    element.style.transition = 'opacity ' + (duration || 200) + 'ms';

    setTimeout(function() {
      element.style.opacity = '1';
    }, 10);
  }

  function fadeOut(element, duration) {
    if (!element) return;
    element.style.transition = 'opacity ' + (duration || 200) + 'ms';
    element.style.opacity = '0';

    setTimeout(function() {
      element.style.display = 'none';
    }, duration || 200);
  }

  function loadProducts(term, updateSuggestions, abortController, modal) {
    if (!modal) return;
    var grid = modal.querySelector('#products-grid');

    if (!grid) return;

    if (!term || term.length < 1) {
      grid.innerHTML = '<div class="empty">Start typing to search...</div>';
      return;
    }

    grid.classList.add('loading');
    grid.innerHTML = '';

    if (!abortController) {
      abortController = createAbortController();
      currentAjaxRequest = abortController;
    }

    if (updateSuggestions) {
      fetchSuggestions(term, abortController.signal)
        .then(function(suggestions) {
          renderSuggestions(suggestions, term, modal);
        });
    }

    var searchURL = Shopify.routes.root + 'search?type=product&q=' + encodeURIComponent(term) + '&view=json';

    fetchJSON(searchURL, abortController.signal)
      .then(function(data) {
        grid.classList.remove('loading');

        if (data.results && data.results.length > 0) {
          var productsToLoad = data.results.slice(0, 10);
          var productsLoaded = 0;
          var products = [];

          if (productsToLoad.length === 0) {
            grid.innerHTML = '<div class="empty">No products found</div>';
            return;
          }

          function checkAndRender() {
            if (productsLoaded === productsToLoad.length) {
              if (products.length === 0) {
                grid.innerHTML = '<div class="empty">No products found</div>';
                return;
              }

              function isOnSale(product) {
                if (product.compare_at_price && product.compare_at_price > product.price) {
                  return true;
                }
                if (product.variants && product.variants.length > 0) {
                  for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                      return true;
                    }
                  }
                }
                return false;
              }

              products.sort(function(a, b) {
                var aOnSale = isOnSale(a);
                var bOnSale = isOnSale(b);
                if (aOnSale && !bOnSale) return 1;
                if (!aOnSale && bOnSale) return -1;
                return 0;
              });

              var productsHtml = '';
              products.forEach(function(product) {
                productsHtml += renderProductItem(product);
              });
              grid.innerHTML = productsHtml;
            }
          }

          productsToLoad.forEach(function(result) {
            var handle = null;
            if (result.url) {
              var match = result.url.match(/\/products\/([^\/\?]+)/);
              if (match) {
                handle = match[1];
              }
            }

            if (!handle) {
              productsLoaded++;
              checkAndRender();
              return;
            }

            fetchJSON(Shopify.routes.root + 'products/' + handle + '.js', abortController.signal)
              .then(function(product) {
                if (product && product.available !== false) {
                  products.push(product);
                }
                productsLoaded++;
                checkAndRender();
              })
              .catch(function(error) {
                if (error.name === 'AbortError') return;
                productsLoaded++;
                checkAndRender();
              });
          });
        } else {
          grid.innerHTML = '<div class="empty">No products found</div>';
        }
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        grid.classList.remove('loading');
        grid.innerHTML = '<div class="empty">Error loading products</div>';
      });
  }

  function loadArticles(term, updateSuggestions, abortController, modal) {
    if (!modal) return;
    var grid = modal.querySelector('#products-grid');

    if (!grid) return;

    if (!term || term.length < 1) {
      grid.innerHTML = '<div class="empty">Start typing to search...</div>';
      return;
    }

    grid.classList.add('loading');
    grid.innerHTML = '';

    if (!abortController) {
      abortController = createAbortController();
      currentAjaxRequest = abortController;
    }

    if (updateSuggestions) {
      fetchSuggestions(term, abortController.signal)
        .then(function(suggestions) {
          renderSuggestions(suggestions, term, modal);
        });
    }

    var searchURL = Shopify.routes.root + 'search?type=article&q=' + encodeURIComponent(term) + '&view=json';

    fetchJSON(searchURL, abortController.signal)
      .then(function(data) {
        grid.classList.remove('loading');

        if (data.results && data.results.length > 0) {
          var articlesHtml = '';
          var articlesToLoad = data.results.slice(0, 10);
          var articlesLoaded = 0;
          var hasArticles = false;

          if (articlesToLoad.length === 0) {
            grid.innerHTML = '<div class="empty">No articles found</div>';
            return;
          }

          articlesToLoad.forEach(function(result) {
            if (!result.url) {
              articlesLoaded++;
              if (articlesLoaded === articlesToLoad.length) {
                if (hasArticles && articlesHtml) {
                  grid.innerHTML = articlesHtml;
                }
              }
              return;
            }

            var articleUrl = result.url + (result.url.indexOf('?') !== -1 ? '&view=json' : '?view=json');
            fetchJSON(articleUrl, abortController.signal)
              .then(function(article) {
                if (article) {
                  articlesHtml += renderArticleItem(article);
                  hasArticles = true;
                }

                articlesLoaded++;

                if (articlesLoaded === articlesToLoad.length) {
                  if (hasArticles && articlesHtml) {
                    grid.innerHTML = articlesHtml;
                  }
                }
              })
              .catch(function(error) {
                if (error.name === 'AbortError') return;
                articlesLoaded++;
                if (articlesLoaded === articlesToLoad.length) {
                  if (hasArticles && articlesHtml) {
                    grid.innerHTML = articlesHtml;
                  }
                }
              });
          });

          if (articlesHtml) {
            grid.innerHTML = articlesHtml;
          }
        }
      })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        grid.classList.remove('loading');
        grid.innerHTML = '<div class="empty">Error loading articles</div>';
      });
  }

  function getActiveTab(modal) {
    if (!modal) return 'products';
    var activeButton = modal.querySelector('.tab-button.active');
    if (activeButton) {
      return activeButton.getAttribute('data-tab') || 'products';
    }
    return 'products';
  }

  function loadContent(term, updateSuggestions, abortController, modal) {
    var activeTab = getActiveTab(modal);
    if (activeTab === 'articles') {
      loadArticles(term, updateSuggestions, abortController, modal);
    } else {
      loadProducts(term, updateSuggestions, abortController, modal);
    }
  }

  function init() {
    var searchInputs = document.querySelectorAll('#search-fullscreen .input-search, #mobile-search-form .input-search');
    var tabButtons = document.querySelectorAll('.tab-button');

    searchInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        var form = this.closest('form');
        if (!form) return;
        var modal = form.querySelector('.search-autocomplete-modal');
        if (!modal) return;

        var term = this.value.trim();
        currentSearchTerm = term;
        currentHoverTerm = null;

        if (term.length >= 1) {
          fadeIn(modal, 200);
          var abortController = createAbortController();
          currentAjaxRequest = abortController;
          loadContent(term, true, abortController, modal);
        } else {
          fadeOut(modal, 200);
        }
      });
    });

    document.addEventListener('mouseenter', function (e) {
      var target = e.target && e.target.closest('.suggestion-item-link');
      if (!target) return;

      e.preventDefault();
      var modal = target.closest('.search-autocomplete-modal');
      if (!modal) return;

      var term = target.getAttribute('data-term');
      if (!term) return;

      currentHoverTerm = term;

      var allLinks = modal.querySelectorAll('.suggestion-item-link');
      var allItems = modal.querySelectorAll('.predictive-search__item');
      allLinks.forEach(function(link) {
        link.classList.remove('active');
      });
      allItems.forEach(function(item) {
        item.setAttribute('aria-selected', 'false');
      });
      target.classList.add('active');
      var itemDiv = target.closest('.predictive-search__item');
      if (itemDiv) {
        itemDiv.setAttribute('aria-selected', 'true');
      }

      var abortController = createAbortController();
      currentAjaxRequest = abortController;
      loadContent(term, false, abortController, modal);
    }, true);

    document.addEventListener('click', function(e) {
      var target = e.target.closest('.suggestion-item-link');
      if (!target) return;

      e.preventDefault();
      var modal = target.closest('.search-autocomplete-modal');
      if (!modal) return;
      var form = modal.closest('form');
      if (!form) return;

      var term = target.getAttribute('data-term');
      if (!term) return;

      var input = form.querySelector('.input-search');

      if (input) {
        input.value = term;
      }

      var allLinks = modal.querySelectorAll('.suggestion-item-link');
      var allItems = modal.querySelectorAll('.predictive-search__item');
      allLinks.forEach(function(link) {
        link.classList.remove('active');
      });
      allItems.forEach(function(item) {
        item.setAttribute('aria-selected', 'false');
      });
      target.classList.add('active');
      var itemDiv = target.closest('.predictive-search__item');
      if (itemDiv) {
        itemDiv.setAttribute('aria-selected', 'true');
      }

      var abortController = createAbortController();
      currentAjaxRequest = abortController;
      loadContent(term, true, abortController, modal);
    });

    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var modal = this.closest('.search-autocomplete-modal');
        if (!modal) return;
        var form = modal.closest('form');
        if (!form) return;

        var buttons = modal.querySelectorAll('.tab-button');
        buttons.forEach(function(btn) {
          btn.classList.remove('active');
        });
        this.classList.add('active');

        var input = form.querySelector('.input-search');
        var term = input ? input.value.trim() : currentSearchTerm;

        if (term && term.length >= 1) {
          var abortController = createAbortController();
          currentAjaxRequest = abortController;
          loadContent(term, false, abortController, modal);
        }
      });
    });

    document.addEventListener('click', function(e) {
      var allModals = document.querySelectorAll('.search-autocomplete-modal');
      allModals.forEach(function(modal) {
        if (modal.style.display === 'none' || modal.style.display === '') {
          return;
        }

        var container = modal.querySelector('.search-autocomplete-container');
        if (!container) return;

        if (!container.contains(e.target)) {
          var form = modal.closest('form');
          var input = form ? form.querySelector('.input-search') : null;

          if (!input || !input.contains(e.target)) {
            fadeOut(modal, 200);
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
